// extracted by mini-css-extract-plugin
module.exports = {"geniusHighlightBottomSheetButton":"FlightCardGeniusHighlightBottomSheetWrapper-module__geniusHighlightBottomSheetButton___dmUg6"};